import { Route, createPageRoute, AppId } from '@lumapps/router';

export const formViewRoute: Route = createPageRoute({
    slug: 'forms/:id',
    appId: AppId.frontOffice,
});

export const prefillFormRoute: Route = createPageRoute({
    slug: 'forms/:id/prefill',
    appId: AppId.frontOffice,
});

export const formSubmissionViewRoute: Route = createPageRoute({
    slug: 'forms/:id/submissions/:submissionId',
    appId: AppId.frontOffice,
});
